import { render, staticRenderFns } from "./alert_list.vue?vue&type=template&id=4eb98a3e&"
import script from "./alert_list.vue?vue&type=script&lang=js&"
export * from "./alert_list.vue?vue&type=script&lang=js&"
import style0 from "./alert_list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports